import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/recaudacion/constancias-de-inscripciones/';

/**
 * GET Constancias de Inscripcion
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getConstanciasdeInscripcion = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Constancia de Inscripcion
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getConstanciadeInscripcion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Constancia de Inscripcion
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postConstanciadeInscripcion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Constancia de Inscripcion
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchConstanciadeInscripcion = async (id, _values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, _values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE Constancia de Inscripcion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteConstanciadeInscripcion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
